import React from "react";
import {
  Form,
  Grid,
  Header,
  HeaderContent,
  HeaderSubheader,
  Icon,
  Segment,
  SegmentGroup,
} from "semantic-ui-react";

import { AIServer } from "../functions/server";
import UserID from "../functions/userid";
import Title from "../product/add_product/title";
import Format from "./format";

import "./table.css";

export default function Chat(props) {
  const [load, setLoad] = React.useState(false);
  const [question, setQuestion] = React.useState("");
  const [answer, setAnswer] = React.useState(false);
  const [response, setResponse] = React.useState(false);
  const [balanceToken, setBalanceToken] = React.useState(false);

  let shopId = props.data.id;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoad(true);
    setAnswer(false);
    setResponse(false);
    const body = {
      q: question,
      shop_id: shopId,
      user_id: UserID(),
    };
    const response = await fetch(`${AIServer()}/query`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (data.error) {
      setAnswer(data.error);
    } else {
      setBalanceToken(data.balance_token);
      setAnswer(data.formatted_results);
      setResponse(data);
    }
    setLoad(false);
  };

  return (
    <div>
      <Title
        shopDetails={props.data}
        menu={true}
        shopId={props.data.id}
        title={"Ask AI - Beta"}
      />
      <SegmentGroup style={{ margin: 10 }}>
        <Segment>
          <Grid>
            <Grid.Column floated="left" width={6}>
              <Header as="h3">
                <Icon name="chat" color="blue" />
                <HeaderContent>
                  Ask AI - Beta
                  <HeaderSubheader>ChatGPT Integrated</HeaderSubheader>
                </HeaderContent>
              </Header>
            </Grid.Column>
            <Grid.Column floated="right" width={2}>
              {balanceToken && <Header as="h4">
                <HeaderContent color="blue">
                  Balance Token:
                  <HeaderSubheader>
                    {balanceToken}
                  </HeaderSubheader>
                </HeaderContent>
              </Header>}
            </Grid.Column>
          </Grid>
        </Segment>
        <SegmentGroup>
          <Segment>
            <Form>
              <Form.TextArea
                label="Your Question"
                placeholder="Type your question here..."
                onChange={(e) => setQuestion(e.target.value)}
              />
              <Form.Button primary onClick={handleSubmit} loading={load}>
                Ask
              </Form.Button>
            </Form>
          </Segment>
          {!answer && !load && (
            <Segment>
              Please type your question and then click on <strong>Ask</strong>
            </Segment>
          )}
          {
            load && (
              <Segment>
                Processing... It might take up to 1 minute to get a response.
              </Segment>
            )
          }
          {answer && (
            <Segment>
              <Format data={JSON.parse(answer)} />
            </Segment>
          )}
        </SegmentGroup>
      </SegmentGroup>
    </div>
  );
}
